import { IAttrValue } from "@multiweb/types/contracts";
import { StringUtils } from "Global/Base/Utils/StringUtils";
import { Globalization } from "../../../../Global/Dom/Globalization";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { IOWObject } from "../../../../OW.Remoting/Remoting/DataTypes/IOWObject";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DefaultEditTemplate } from "../Templates/DataTypeEditTemplates/DefaultEditTemplate";
import { LOVTemplate } from "../Templates/DataTypeTemplates/LOVTemplate";
import { Column } from "./Column";
import { IColumnDefinition, IColumnParameters, ILovColumnParameters } from "./ColumnFactory";

export class LovColumn extends Column {
    //#region Methods
    private _showAttrs: string[];

    public get showAttrs(): string[] {
        return this._showAttrs;
    }

    protected static override get observedAttributes(): string[] {
        return ["data-showattrs"].concat(Column.observedAttributes);
    }

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        let frmVal: string;
        if (data instanceof Array) {
            let values: IAttrValue[];
            if (data.length === 1) {
                const firstValue = AttrValueReader.read(data[0]);
                values = firstValue instanceof IOWObject ? await firstValue.getValues(this._showAttrs) : data;
            } else {
                values = data;
            }
            frmVal = values.map((item) => StringUtils.stringToHTMLText(Globalization.formatValue(AttrValueReader.read(item)))).filter((item) => item.trim().length > 0)
                .join("</span><span> | </span><span class='lov-attribute'>");
        } else {
            frmVal = StringUtils.stringToHTMLText(Globalization.formatValue(AttrValueReader.read(data)));
        }
        return `<span class='lov-attribute first-attr'>${frmVal}</span>`;
    }

    /**
     * Zinicializuje data sloupce
     * @param definition - definice sloupce
     * @param params - dodatečné parametry
     */
    public override initialize(definition: IColumnDefinition, params?: IColumnParameters): void {
        super.initialize(definition, params);

        if (params != null && params instanceof ILovColumnParameters)
            this._additionalParameters = params;

        // Zpracujeme ihned, šahá se na něj během vytváření sloupců při plnění dataSource (ještě nemusel proběhnout attributeChangedCallback)
        this._parseShowAttrs(definition.showAttrs);
    }

    /**
     * Zpracuje vstupní pole atributů ke zobrazení
     * @param showAttrs
     */
    protected _parseShowAttrs(showAttrs: string[]): void {
        if (showAttrs == null) {
            return;
        }

        if (showAttrs.length === 0) {
            this.attrNames = [this.attrName];

            return;
        }

        const attributes: string[] = [];

        for (const subattr of showAttrs) {
            attributes.push(`${this.attrName}.${subattr}`);
        }

        this.attrNames = attributes;
        this._showAttrs = showAttrs;

        this.dispatchEvent(new CustomEvent("dataColumnRefresh", {
            detail: {
                attrName: this.attrName,
                attrNames: this.attrNames,
                column: this,
            },
        }));
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this._showAttrs = [];
        this.itemTemplate = new LOVTemplate();
        this.editItemTemplate = new DefaultEditTemplate();
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        switch (attrName) {
            case "data-showattrs":
            {
                this._parseShowAttrs(newVal ? newVal.split(";") : null);
                break;
            }
        }
    }
    //#endregion HTMLElement
} //end Column

registerCustomElement("tsc-lovcolumn", LovColumn);
